import React from 'react';
import { formatPercent } from 'utils';

export const CustomBarLabel = ({
  x,
  y,
  width,
  value,
  height,
  fill,
  offset,
  isPercent
}: any) => {
  const isValueNegative = value < 0;
  return (
    <text
      style={{
        fontSize: '13px'
      }}
      height={height}
      className="recharts-text recharts-label"
      x={x + width / 2}
      fill={fill}
      y={isValueNegative ? y + offset : y - offset}
      textAnchor="middle"
    >
      <tspan x={x + width / 2} dy={isValueNegative ? '0.71em' : '0em'}>
        {isPercent ? formatPercent(value) : value}
      </tspan>
    </text>
  );
};
